import React, { PropsWithChildren } from 'react'
import {
  TableSortLabel as MuiTableSortLabel,
  useTheme,
  Box,
} from '@mui/material'
import { styled } from '@mui/material/styles'

export interface ITableSortLabelProps {
  direction: 'desc' | 'asc' | undefined
  disabled?: boolean
  orderBy: string
  hideSortIcon?: boolean
  orderName: string
  onOrderByChanged: (order: string) => void
}

const CustomTableSortLabel = styled(MuiTableSortLabel)(({ theme }) => ({
  '&.Mui-active': {
    color: theme.palette.primary.main,
  },
}))

const TableSortLabel = ({
  direction,
  disabled = false,
  orderBy,
  hideSortIcon = false,
  orderName,
  onOrderByChanged,
  children,
  ...props
}: PropsWithChildren<ITableSortLabelProps>) => {
  const theme = useTheme()
  return (
    <CustomTableSortLabel
      sx={{
        display: 'flex',
        flexGrow: 1,
        width: '100%',
        paddingRight: '12px',
        alignItems: 'center',
        color: orderBy === orderName ? theme.palette.primary.main : null,
        fontWeight: orderBy === orderName ? 600 : null,
      }}
      active={orderBy === orderName}
      direction={(direction as 'asc' | 'desc')}
      onClick={() => onOrderByChanged(orderName)}
      disabled={disabled}
      IconComponent={() => null}
      {...props}
    >
      {children}
      {!disabled && !hideSortIcon && (
        <Box sx={{ fontWeight: 600, fontSize: '12px' }} ml={2}>
          <i
            className={`fa-regular fa-${
              orderBy !== orderName || direction === 'desc'
                ? 'arrow-down-wide-short'
                : 'arrow-up-wide-short'
            }`}
          />
        </Box>
      )}
    </CustomTableSortLabel>
  )
}



export default TableSortLabel
